import { generateResourceReducer } from '../generators/resource.reducer';

import * as types from './agenda.types';
import * as constants from './agenda.constants';

export const agendaReducer = generateResourceReducer<types.IAgenda>({
  STORE: constants.STORE_AGENDA,
  CLEAR: constants.CLEAR_AGENDA,
});
